<template>
  <div class="d-flex flex-column" style="min-height: 100vh">
    <!-- content  -->
    <div style="flex: 1">
      <!-- logo -->
      <logo_display></logo_display>
      <!-- logo -->

      <!-- heading -->
      <page_banner page_title="尖沙咀及元朗會議室預約系統" />
      <!-- heading -->

      <b-container fluid class="mt-5">
        <b-container
          class="text-center d-flex flex-column justify-content-center align-items-center"
        >
          <!-- login form -->
          <b-form class="w-50 text-center" @submit.prevent="handleLogin()">
            <b-form-input
              class="mb-3"
              id="fbo-id"
              type="text"
              v-model="form.fbo_id"
              pattern="^[0-9]{12}$"
              maxlength="12"
              inputmode="numeric"
              required
              placeholder="輸入FBO ID"
            ></b-form-input>
            <b-form-input
              class="mb-3"
              id="password"
              type="password"
              v-model="form.password"
              required
              placeholder="輸入密碼"
            ></b-form-input>

            <b-button type="submit" variant="outline-primary" class="mb-3"
              >登入</b-button
            >
          </b-form>
          <!-- login form -->

          <!-- error message display -->
          <ErrorDisplay :error_message="error_message" />
          <!-- error message display -->
        </b-container>
      </b-container>
    </div>
    <!-- content  -->

    <!-- footer -->
    <!-- warning -->
    <b-container class="d-flex justify-content-center text-center">
      <b-alert variant="warning" class="my-alert mb-0" show>
        如需<b>開設帳戶</b>或
        <b>忘記密碼</b>，請WhatsApp <b>(852) 5374 9638 </b>/ 致電
        <b>(852) 2369 9638</b>
        顧客服務熱線。
      </b-alert>
    </b-container>
    <!-- warning -->
    <!-- footer -->
  </div>
</template>

<script>
import api from "@/api";
import page_banner from "./page_banner.vue";
import logo_display from "./logo_display.vue";
import ErrorDisplay from "./ErrorDisplay.vue";
export default {
  data() {
    return {
      form: {
        fbo_id: "",
        password: "",
      },
      error_message: "",
    };
  },
  methods: {
    async handleLogin() {
      try {
        const tabId = window.name || `tab_${Date.now()}`;
        window.name = tabId;

        const response = await api.post("/api/login/", {
          fbo_id: this.form.fbo_id,
          password: this.form.password,
        });

        if (response.data.status === "success") {
          localStorage.setItem(
            `access_token_${tabId}`,
            response.data.access_token
          );
          localStorage.setItem(
            `refresh_token_${tabId}`,
            response.data.refresh_token
          );
          localStorage.setItem(`fbo_id_${tabId}`, response.data.user.fbo_id);
          this.$router.push("/makeBooking");
        } else {
          this.error_message = response.data.error_message;
        }
      } catch (err) {
        this.error_message = err.response?.data?.message || "登入失敗";
      }
    },
  },
  components: {
    logo_display,
    ErrorDisplay,
    page_banner,
  },
};
</script>

<style>
.my-alert {
  white-space: normal;
}

@media (min-width: 768px) {
  .my-alert {
    white-space: nowrap;
  }
}
</style>
